/**
 * Anonymous Session Banner
 *
 * Displays a warning banner for anonymous users encouraging them to sign up
 * to save their comparisons and unlock full features.
 */

import React from 'react';
import { Link } from 'react-router-dom';

interface AnonymousBannerProps {
  message?: string;
  showUpgradeButton?: boolean;
  className?: string;
}

export const AnonymousBanner: React.FC<AnonymousBannerProps> = ({
  message = 'Guest mode: this comparison will disappear when you leave — create an account to save it',
  showUpgradeButton = true,
  className = ''
}) => {
  return (
    <div
      className={`bg-amber-900/20 border border-amber-500/50 rounded-lg p-4 flex items-center justify-between ${className}`}
      data-testid="anonymous-banner"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center gap-3">
        <div className="text-amber-400 text-lg" aria-hidden="true">
          ⚠️
        </div>
        <div>
          <p className="text-amber-300 font-medium text-sm">
            {message}
          </p>
        </div>
      </div>

      {showUpgradeButton && (
        <Link
          to="/signup"
          className="px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg font-medium transition-colors text-sm whitespace-nowrap"
          data-testid="anonymous-banner-signup-button"
        >
          Sign Up Free
        </Link>
      )}
    </div>
  );
};
